import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { coachData } from '../data/mockData';
import ThemeToggle from './ThemeToggle';
import '../styles/navigation.css';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Journey', href: '#journey' },
    { label: 'Programs', href: '#programs' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className={`nav-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-content">
          {/* Logo */}
          <a href="#home" className="nav-logo" onClick={(e) => scrollToSection(e, '#home')}>
            <img src={coachData.logo} alt="ClutchCricket" className="logo-image" />
          </a>

          {/* Desktop Menu */}
          <div className="nav-menu desktop-menu">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="nav-link"
                onClick={(e) => scrollToSection(e, item.href)}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Right Side Actions */}
          <div className="nav-actions desktop-actions">
            <ThemeToggle />
            <a
              href="#contact"
              className="nav-cta"
              onClick={(e) => scrollToSection(e, '#contact')}
            >
              <Phone size={18} />
              Book Trial
            </a>
          </div>

          {/* Mobile Actions */}
          <div className="mobile-nav-actions">
            <ThemeToggle />
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
          <div className="mobile-menu-content">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="mobile-nav-link"
                onClick={(e) => scrollToSection(e, item.href)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className="nav-cta mobile-cta"
              onClick={(e) => scrollToSection(e, '#contact')}
            >
              <Phone size={18} />
              Book Trial
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
